import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { DiscoveryAppsPage } from "@/features/discovery";

/**
 * `GET /v1/discovery/apps` accepts no query parameters server-side (see
 * `features/discovery/types.ts`) — page/limit/severity/decision below are
 * URL-synced UI state applied entirely client-side against the full list,
 * the same "shareable filtered view" contract every other list route
 * follows, just filtered locally instead of server-side.
 */
const discoveryAppsSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  limit: z.coerce.number().int().min(1).max(100).catch(20),
  q: z.string().optional().catch(undefined),
  severity: z.string().optional().catch(undefined),
  decision: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/discovery/")({
  validateSearch: discoveryAppsSearchSchema,
  component: () => (
    <PermissionGuard module="discovery">
      <DiscoveryAppsPage />
    </PermissionGuard>
  ),
});
